import {h1} from '@styled-system/recipes';
import {Box, HStack, styled, VStack} from '@styled-system/jsx';
import DateCard from '~/routes/promotions.$promotionId/DateCard';
import CountdownCard from '~/routes/promotions.$promotionId/CountdownCard';

type PromotionHeaderProps = {
  title: string
  startDate: Date
  endDate: Date
  entryLimit?: number
};

const PromotionHeader = ({title, startDate, endDate, entryLimit}: PromotionHeaderProps) => {
  return (
    <>
      <VStack alignItems="stretch" width="100%" gap={0}>
        <h1 className={h1()}>{title}</h1>
        {(entryLimit ?? 0) > 0 ?
          <Box
            color="primary"
            textTransform="uppercase"
            fontSize="xl"
            fontFamily="heading"
          >
            <styled.span fontWeight="bold">{entryLimit!.toLocaleString('en-US')} spots</styled.span> Available
          </Box> :
          <Box
            bgColor="primary"
            color="white"
            py={1}
            px={2}
            rounded="sm"
            textTransform="uppercase"
            fontWeight="bold"
            fontSize={{base: 'sm', md: 'md'}}
          >
            Win this {title} Every purchase is an entry
          </Box>
        }
      </VStack>
      <VStack alignContent="stretch">
        <HStack justifyContent="stretch" width="full" hideBelow="sm">
          <DateCard
            title="Start Date"
            date={startDate}
          />
          <DateCard
            title="End Date"
            date={endDate}
          />
        </HStack>
        <CountdownCard endDate={endDate}/>
      </VStack>
    </>
  );
};

export default PromotionHeader;
